import { Card, Col, Row, Skeleton } from "antd";
import React from "react";
import styles from "./_styles.less";
import { useSelector } from "react-redux";
import { dataAnalyticsDashboardSelector, dataAnalyticsLoadingSelector } from "@/store/dataAnalytics";
import { useTranslation } from "react-i18next";
import useFormatter from "@/hooks/useFormatter";

export default function DashboardScorecards() {
  const dadosLoading = useSelector(dataAnalyticsLoadingSelector);
  const dashboardData = useSelector(dataAnalyticsDashboardSelector);
  const { t } = useTranslation();
  const { formatBytes } = useFormatter();

  const scorecardsArray = [
    { title: "Acessos", value: dashboardData?.totalizadores?.totalAcessos ?? "-" },
    { title: "Empresas", value: dashboardData?.totalizadores?.totalEmpresas ?? "-" },
    { title: "Documentos", value: dashboardData?.totalizadores?.totalDocumentos ?? "-" },
    { title: "Armazenamento", value: formatBytes(dashboardData?.totalizadores?.totalEspaco) },
    { title: "Tarefas", value: dashboardData?.totalizadores?.totalTarefas ?? "-" },
  ];

  return (
    <Row gutter={[8, 8]} className={styles["row-dashboard"]} justify="space-between">
      {scorecardsArray.map((kpi) => {
        return (
          <Col key={kpi.title} flex="1 1 250px">
            <Card title={t(kpi.title)} className={styles["card-kpi"]}>
              <Skeleton loading={dadosLoading} active paragraph={false}>
                <h2 className={styles["kpi-number"]}>{kpi.value}</h2>
              </Skeleton>
            </Card>
          </Col>
        );
      })}
    </Row>
  );
}
